module.exports = __webpack_public_path__ + "media/images/contest-disabled-label-center-3f19245088136ca11cf193d1f2f2efbb.png";